webpackJsonp([234125357286039],{

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'index.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the root JavaScript file of the application, and is responsible for building and mounting the application to the DOM.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It also attaches the Lore singleton to the window, so you can access it from the command line in case you need to play with it, such as:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Manually executing actions (',
	        _react2.default.createElement(
	          'code',
	          null,
	          'lore.actions.tweet.create(...)'
	        ),
	        ')'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Checking the reducer state (',
	        _react2.default.createElement(
	          'code',
	          null,
	          'lore.store.getState().tweet.byId[\'1\']'
	        ),
	        ')'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Inspecting the config (',
	        _react2.default.createElement(
	          'code',
	          null,
	          'lore.config.connections.default.apiRoot'
	        ),
	        ')'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Etc.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import lore from \'lore\';\n      import _ from \'lodash\';\n\n      // Allows you to access your lore app globally as well as from within\n      // the console. Remove this line if you don\'t want to be able to do that.\n      window.lore = lore;\n\n      // Hooks\n      import auth from \'lore-hook-auth\';\n      import actions from \'lore-hook-actions\';\n      import bindActions from \'lore-hook-bind-actions\';\n      import collections from \'lore-hook-collections\';\n      import connections from \'lore-hook-connections\';\n      import connect from \'lore-hook-connect\';\n      import models from \'lore-hook-models\';\n      import react from \'lore-hook-react\';\n      import reducers from \'lore-hook-reducers\';\n      import redux from \'lore-hook-redux\';\n      import router from \'lore-hook-router\';\n\n      // Summon the app!\n      lore.summon({\n        hooks: {\n          auth,\n          actions,\n          bindActions,\n          collections,\n          connections,\n          connect,\n          models,\n          react,\n          reducers,\n          redux: _.extend(redux, {\n            dependencies: [\'reducers\', \'auth\']\n          }),\n          router\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-index-js-js-02358c150605217be59e.js